import { CodeBlock } from '../../../../shared-components';
import { IGetEnvironmentResponse } from '../../../../models/environmentModel';
import { devSettings } from '../../../../../@xmcloud/core/messages/en';
import {
	buildOptionalSecretLine,
	pickContextId,
} from './developerSettingsEnvVars';

const { editingSecretNotFound } = devSettings;

export const AngularSettings: React.FC<{
	environmentDetail: IGetEnvironmentResponse;
	isPreview: boolean;
	siteName: string;
	editingSecret: string;
	isEditingSecretAvailable: boolean;
}> = ({
	environmentDetail,
	isPreview,
	siteName,
	editingSecret,
	isEditingSecretAvailable,
}) => {
	const previewContextId = environmentDetail?.previewContextId || '';
	const liveContextId = environmentDetail?.liveContextId || '';
	const contextId = pickContextId(isPreview, previewContextId, liveContextId);

	const envVariablesLines = [
		`SITECORE_EDGE_CONTEXT_ID=${contextId}`,
		`CSDK_PUBLIC_SITECORE_EDGE_CONTEXT_ID=${contextId}`,
		`CSDK_PUBLIC_DEFAULT_SITE_NAME=${siteName}`,
		...buildOptionalSecretLine({
			isPreview,
			isAvailable: isEditingSecretAvailable,
			variableName: 'SITECORE_EDITING_SECRET',
			value: editingSecret,
			notFoundText: editingSecretNotFound,
		}),
	];

	return (
		<CodeBlock
			items={envVariablesLines}
			clipboardText={envVariablesLines.join('\n')}
			data-testid="code-block"
			key="angular-code-block"
		/>
	);
};
